import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Clock } from "lucide-react";

export const LateAlerts = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    const load = () => api.get("/staff/arrivals").then((r) => setRows(r.data.filter((a) => a.status === "late"))).catch(() => {});
    load(); const t = setInterval(load, 30000); return () => clearInterval(t);
  }, []);
  if (!rows.length) return null;
  return (
    <div className="mb-4 rounded-2xl border border-amber-400/40 bg-amber-400/10 p-4" data-testid="late-alerts">
      <p className="font-bold text-amber-300 flex items-center gap-2"><Clock className="w-4 h-4" />Parents running late today</p>
      <div className="mt-2 flex flex-wrap gap-2">
        {rows.map((a) => <span key={a.id} className="text-xs bg-white/10 text-white rounded-full px-3 py-1" data-testid={`late-alert-${a.id}`}>{a.child_name} · {a.label.replace("Running late — ", "")} · {a.parent_name}</span>)}
      </div>
    </div>
  );
};
